module.exports = __webpack_public_path__ + "img/CYSABG.202f3764.jpg";